/**
 * Reads the active locale from Zustand persisted storage.
 * Used by API classes to inject Accept-Language header on GET requests.
 * Returns 'es' if no locale is stored or localStorage is unavailable.
 */
export function getLocale() {
  try {
    const stored = localStorage.getItem("educa360-locale");
    if (!stored) return "es";
    const parsed = JSON.parse(stored);
    return parsed?.state?.locale || "es";
  } catch {
    return "es";
  }
}
